/* eslint-disable import/no-duplicates */
import { useEffect, useMemo, useState } from 'react';
import { format } from 'date-fns';
import ptBr from 'date-fns/locale/pt-BR';
import { MdClose, MdGavel, MdSearch, MdSend } from 'react-icons/md';
import { ReactComponent as NoteMoney } from 'assets/images/noteMoney.svg';
import { RiPencilFill } from 'react-icons/ri';
import { useSelector } from 'react-redux';
import { StepClaimStatus } from 'store/modules/claims/types';
import { ApplicationState } from 'store/store.inteface';
import { STEPS_STATUS } from 'utils/statusEnum';

export const useClaimsStatusHistory = () => {
  const claimStatus = useMemo(
    () => ({
      [STEPS_STATUS.CommunicationDate]: {
        icon: MdSend,
        color: 'normal',
      },
      [STEPS_STATUS.Documentation]: {
        icon: MdSend,
        color: 'normal',
      },
      [STEPS_STATUS.SuccessLossCalculation]: {
        icon: MdSend,
        color: 'normal',
      },
      [STEPS_STATUS.SignedTerm]: {
        icon: MdSend,
        color: 'normal',
      },
      [STEPS_STATUS.DocumentsSent]: {
        icon: MdSearch,
        color: 'warning',
      },
      [STEPS_STATUS.FailedLossCalculation]: {
        icon: MdSearch,
        color: 'warning',
      },
      [STEPS_STATUS.CreditSchedule]: {
        icon: MdGavel,
        color: 'warning',
      },
      [STEPS_STATUS.DocumentRequest]: {
        icon: RiPencilFill,
        color: 'error',
      },
      [STEPS_STATUS.LossCalculation]: {
        icon: RiPencilFill,
        color: 'error',
      },
      [STEPS_STATUS.DischargeTerms]: {
        icon: RiPencilFill,
        color: 'error',
      },
      [STEPS_STATUS.NegativeLetter]: {
        icon: MdClose,
        color: 'error',
      },
      [STEPS_STATUS.AdministrativeClosure]: {
        icon: MdClose,
        color: 'error',
      },
      [STEPS_STATUS.InvalidInformations]: {
        icon: MdClose,
        color: 'error',
      },
      [STEPS_STATUS.FullIndemnity]: {
        icon: NoteMoney,
        color: 'success',
      },
    }),
    [],
  );

  const { claimById: claims } = useSelector(
    (state: ApplicationState) => state.claims,
  );

  const stepClaimStatus = claims?.statusArray;

  const [mountedClaimsHistory, setMountedClaimsHistory] = useState<
    StepClaimStatus[]
  >([]);

  useEffect(() => {
    const pageStatus = stepClaimStatus && Object.values(stepClaimStatus).flat();
    if (pageStatus?.length > 0) {
      const claimsHistory = pageStatus
        .filter((claim: any) => claim?.description && claim.date)
        .map((claim: any) => {
          const { status, description, date } = claim;
          const claimStatusResultExcept = claimStatus[status + description];

          return {
            ...claim,
            ...(claimStatusResultExcept ?? claimStatus[description]),
            date: format(new Date(date), 'dd MMM yyyy', { locale: ptBr }),
          };
        });
      setMountedClaimsHistory(claimsHistory);
    }
  }, [claimStatus, stepClaimStatus]);

  return mountedClaimsHistory;
};
